'use client'

import { FiShoppingCart } from 'react-icons/fi'
import { useOptimizedCartStore } from '@/stores/optimized-cart-store'
import { useCallback } from 'react'
import { CLSSafeCartBadge } from './CLSSafeCartNotifications'

export default function CartCountBadge() {
  // Get cart count from store - use number of unique items, not total quantity
  const { items, openSidebar } = useOptimizedCartStore()
  const itemCount = items.length
  
  const handleClick = useCallback(() => {
    openSidebar()
  }, [openSidebar])
  
  return (
    <button
      onClick={handleClick}
      className="relative p-2 text-text-main hover:text-secondary transition-colors duration-200"
      aria-label={`View cart${itemCount > 0 ? ` (${itemCount} items)` : ''}`}
      style={{ minWidth: '44px', minHeight: '44px' }} // Ensure consistent touch target
    >
      <FiShoppingCart className="h-6 w-6" />
      <CLSSafeCartBadge count={itemCount} />
    </button>
  )
} 